// Approval circuits (server approvalFlow.ts, 006): the approvers a request goes through, in order, before its
// engineer. Edited in Configurare; every request keeps the circuit it was filed under.

// Approvers a circuit can have (server CIRCUIT_STEPS, keep in sync)
export const CIRCUIT_STEPS = [
  { value: "sef", text: "Șef departament", hint: "Șeful departamentului care depune demersul", icon: "mdi-account-tie-outline" },
  { value: "dtisef", text: "Șef DTI", hint: "Șeful Departamentului Tehnologii Informaționale", icon: "mdi-shield-account-outline" },
  { value: "contabilitate", text: "Contabilitate", hint: "Verifică dacă corespund nr. de inventar și persoana responsabilă", icon: "mdi-calculator-variant-outline" },
  { value: "rector", text: "Rector", hint: "Aprobă", icon: "mdi-school-outline" },
];

// What a request waits for (server WAITING_LABELS)
const WAITING_LABELS = {
  sef: "Șef departament",
  dtisef: "Șef DTI",
  contabilitate: "Contabilitate",
  rector: "Rector",
  examinare: "Șef DTI (examinare)",
};

// Who does the work of a request (requests.engineer_role); "admin" = every admin account, when Configurare says so
export const ENGINEER_LABELS = { inginer: "Inginer", "inginer-pc": "Inginer PC", admin: "Administrator" };

export function stepText(key) {
  return WAITING_LABELS[key] || key || "";
}

export function stepIcon(key) {
  if (key === "examinare") return "mdi-magnify-scan";
  return (CIRCUIT_STEPS.find((s) => s.value === key) || {}).icon || "mdi-account-outline";
}

/** "Șef departament → Contabilitate → Rector → Inginer" */
export function circuitPathText(steps, engineer = "Inginer") {
  const list = steps || [];
  return list.length ? [...list.map(stepText), engineer].join(" → ") : `Direct la ${engineer.toLowerCase()}`;
}
